/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Internal dependencies
 */
import StoryEditor from './storyEditor';
import Dialog from './components/dialog';

export * from './components/transform';
export * from './components/previewPage';
export * from './app/config';
export * from './app/story';
export * from './app/api';
export * from './components/header';
export * from './app/currentUser';
export * from './output';
export * from './spellCheck';
export * from './testUtils';
export * from './types';

export { default as getStoryPropsToSave } from './app/story/utils/getStoryPropsToSave';
export { default as FontContext } from './app/font/context';
export { default as useLoadFontFiles } from './app/font/actions/useLoadFontFiles';
export { default as StoryPropTypes } from './types';
export { GlobalStyle } from './theme';
export { default as theme } from './theme'; // @todo To be refactored.
export { GlobalStyle as CropMoveableGlobalStyle } from './components/moveable/cropStyle';
export { default as InterfaceSkeleton } from './components/layout';
export { default as Tooltip } from './components/tooltip';
export { useUploadWithPreview } from './components/canvas';
export { default as UserContext } from './userContext';
export { ConfigProvider as EditorConfigProvider } from './app/config';
export { useLocalMedia } from './app';

export { Dialog };
export default StoryEditor;
